export enum MeasureOfCategory {
    light = 'Licht',
    moderate = 'Matig',
    none = 'Geen',
    severe = 'Ernstig',
}
